import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { appImages, eSign, isInovize } from '../../../constants';

const styles = StyleSheet.create({
  page: {
    paddingTop: 100, // enough space for banner
    paddingBottom: 60,
    fontSize: 12,
  },
  banner: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 90, // adjust based on your banner height
    paddingBottom: 10,
    borderBottom: '1px solid #000'
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    // height: 40, // adjust based on your banner height
    objectFit: 'cover',
  },
  container: {
    marginVertical: 30,
    marginHorizontal: 40
  },
  table: {
    display: 'table',
    width: 'auto',
    marginVertical: 10,
    border: '1px solid #000',
  },
  row: {
    flexDirection: 'row',
  },
  cell: {
    paddingVertical: 5,
    fontSize: 10,
    flexGrow: 1,
    textAlign: 'center',
  },
  bold: {
    fontWeight: 'bold',
  },
  rightBorder: {
    borderRight: '1pt solid #000',
  },
  eSignImage: {
    height: 100,
    alignSelf: 'flex-start',
    objectFit: 'contain',
  },
});

const Certificate = ({ today, vehicleNo, imei, simNo, installDate }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Banner Image at the Top */}
      <Image style={styles.banner} src={appImages.gpsBanner} />

            <View style={styles.container}>
                {/* Body Content */}
                <Text style={{ marginVertical: 10 }}>Date: {today}</Text>
                <Text style={[styles.bold, { marginVertical: 20 }, { textAlign: "center", textDecoration: "underline" }]}>To Whomsoever It May Concern</Text>
                <Text style={{ marginVertical: 10 }}>Dear Sir/Madam,</Text>
                <Text style={{ marginVertical: 10 }}>
                    This is to certify that we have installed the GPS tracking system in the
                    mentioned vehicle, and the details are as below:
                </Text>

                <View style={styles.table}>
                    <View style={[styles.row, { borderBottom: "1px solid #000"}]}>
                        <Text style={[styles.cell, styles.bold, styles.rightBorder, { flex: 1}]}>Sl No</Text>
                        <Text style={[styles.cell, styles.bold, styles.rightBorder, { flex: 2}]}>Vehicle No</Text>
                        <Text style={[styles.cell, styles.bold, styles.rightBorder,  { flex: 3}]}>Device IMEI</Text>
                        <Text style={[styles.cell, styles.bold, styles.rightBorder,  { flex: 3}]}>SIM No</Text>
                        <Text style={[styles.cell, styles.bold, { flex: 3}]}>Installation Date</Text>
                    </View>
                    <View style={styles.row}>
                        <Text style={[styles.cell, styles.rightBorder, { flex: 1 }]}>1</Text>
                        <Text style={[styles.cell, styles.rightBorder, { flex: 2 }]}>{vehicleNo}</Text>
                        <Text style={[styles.cell, styles.rightBorder, { flex: 3 }]}>{imei}</Text>
                        <Text style={[styles.cell, styles.rightBorder, { flex: 3 }]}>{simNo}</Text>
                        <Text style={[styles.cell, { flex: 3 }]}>{installDate}</Text>
                    </View>
                </View>

                <Text style={{ marginVertical: 20 }}>
                    The above information is true and correct to the best of our knowledge.
                </Text>
                <Text style={{ marginVertical: 10 }}>Thanking You,</Text>
                <Text style={{ marginVertical: 10 }}>For, <Text style={styles.bold}>SHREE BHAGWATI TRACKING</Text></Text>
                <Image style={styles.eSignImage} src={eSign[isInovize ? "inovize" : "shreebhagwatitracking"]} />
                <Text style={styles.bold}>Authorised Signatory</Text>
            </View>

      {/* Footer */}
      <Image style={styles.footer} src={appImages.gpsFooter} />

    </Page>
  </Document>
);

export default Certificate;